import useSWR from '../../../../../node_modules/swr/core/dist/index.mjs';
import { useNetworkClient } from './useApiNetworkClient.mjs';

const useAdminPortalConfig = ({ shouldFetch })=>{
    const networkClient = useNetworkClient();
    return useSWR(shouldFetch ? '/b2b/admin_portal_config' : null, ()=>{
        return networkClient.fetchSDK({
            url: '/b2b/admin_portal_config',
            method: 'GET'
        });
    });
};

export { useAdminPortalConfig };
//# sourceMappingURL=useAdminPortalConfig.mjs.map
